module.exports = __webpack_public_path__ + "img/icon13.9d5c089e.png";